import { Base, importWhenVisible, importWhenPrefersMotion } from '@studiometa/js-toolkit';
import { Action, Target, Tabs, LargeText, ScrollAnimationParent } from '@studiometa/ui';
import Slider from './Slider/index.js';
import Instagram from './Instagram/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import Tooltips from './Tooltips.js';
import HeroSlider from './HeroSlider.js';
import Panel from './Panel.js';
import ProductVariants from './ProductVariants/index.js';
import Presse from './Presse/index.js';
import GalleryScale from './GalleryScale/index.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      HeroHome: (app) => importWhenVisible(() => import('./HeroHome/index.js'), 'HeroHome', app),
      WatchTimeReader: (app) =>
        importWhenVisible(() => import('./WatchTimeReader.js'), 'WatchTimeReader', app),
      HeroCollection: (app) =>
        importWhenVisible(() => import('./HeroCollection/index.js'), 'HeroCollection', app),
      BlogHero: (app) => importWhenVisible(() => import('./BlogHero/index.js'), 'BlogHero', app),
      VideoScroll: (app) => importWhenVisible(() => import('./VideoScroll.js'), 'VideoScroll', app),
      Action,
      Target,
      ScrollAnimationParent,
      Tabs,
      LargeText,
      Slider,
      Instagram,
      ProductLastViewed,
      Tooltips,
      HeroSlider,
      Panel,
      ProductVariants,
      GalleryScale,
      Presse,
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      Stories: (app) => importWhenVisible(() => import('./Stories/index.js'), 'Stories', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      Video: (app) => importWhenVisible(() => import('./Video.js'), 'Video', app),
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
      KeyNumber: (app) => importWhenVisible(() => import('./KeyNumber.js'), 'KeyNumber', app),
      ParallaxMedia: (app) =>
        importWhenVisible(() => import('./ParallaxMedia.js'), 'ParallaxMedia', app),
      VideoScale: (app) =>
        importWhenVisible(() => import('./VideoScale/index.js'), 'VideoScale', app),
      VideoParallax: (app) =>
        importWhenVisible(() => import('./VideoParallax/index.js'), 'VideoParallax', app),
      ColumnSlideshow: (app) =>
        importWhenVisible(() => import('./ColumnSlideshow.js'), 'ColumnSlideshow', app),
      ImageScrollScale: (app) =>
        importWhenVisible(() => import('./ImageScrollScale/index.js'), 'ImageScrollScale', app),
      CollectionBanner: (app) =>
        importWhenVisible(() => import('./CollectionBanner/index.js'), 'CollectionBanner', app),
      MediaCropAnimation: (app) =>
        importWhenVisible(() => import('./MediaCropAnimation/index.js'), 'MediaCropAnimation', app),
      MediaReveal: (app) =>
        importWhenVisible(
          () => importWhenPrefersMotion(() => import('./MediaReveal.js')),
          'MediaReveal',
          app,
        ),
      TextReveal: (app) =>
        importWhenVisible(
          () => importWhenPrefersMotion(() => import('./TextReveal.js')),
          'TextReveal',
          app,
        ),
      CelestialMap: (app) =>
        importWhenVisible(() => import('./CelestialMap.js'), 'CelestialMap', app),
    },
  };
}
